export function updateQueryStringParameter(uri_old, key, value) {
    // remove the hash part before operating on the uri
    const i = uri_old.indexOf('#');
    const hash = i === -1 ? '' : uri_old.substr(i);
    let uri = i === -1 ? uri_old : uri_old.substr(0, i);
    const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        uri = uri.replace(re, `$1${key}=${value}$2`);
    }
    else {
        uri = `${uri + separator + key}=${value}`;
    }
    return uri + hash; // finally append the hash as well
}
export function removeHashStringParameter(uri_old, key) {
    const i = uri_old.indexOf('#');
    let hash = i === -1 ? '' : uri_old.substr(i);
    const uri = i === -1 ? uri_old : uri_old.substr(0, i);
    const re = new RegExp(`([#&])${key}=.*?(&|$)`, 'i');
    if (hash.match(re)) {
        hash = hash.replace(re, '$1$2');
    }
    return uri + hash; // finally append the hash as well
}
